const API_BASE = process.env.REACT_APP_API_URL || '/api';

class ApiService {
  constructor() {
    this.baseUrl = API_BASE;
  }

  getHeaders() {
    const headers = { 'Content-Type': 'application/json' };
    const token = localStorage.getItem('hp_token');
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return headers;
  }

  async request(method, endpoint, data = null) {
    const config = {
      method,
      headers: this.getHeaders(),
    };
    if (data && method !== 'GET') {
      config.body = JSON.stringify(data);
    }
    const url = `${this.baseUrl}/${endpoint}`;
    const response = await fetch(url, config);
    const json = await response.json();
    if (!response.ok) throw new Error(json.error || 'Request failed');
    return json;
  }

  get(endpoint) { return this.request('GET', endpoint); }
  post(endpoint, data) { return this.request('POST', endpoint, data); }
  put(endpoint, data) { return this.request('PUT', endpoint, data); }
  delete(endpoint) { return this.request('DELETE', endpoint); }

  // Auth
  login(data) { return this.post('auth/login', data); }
  register(data) { return this.post('auth/register', data); }
  getProfile() { return this.get('auth/profile'); }
  updateProfile(data) { return this.post('auth/update-profile', data); }

  // Content
  getCategories() { return this.get('categories'); }
  getCategory(slug) { return this.get(`categories/${slug}`); }
  getAttractions() { return this.get('attractions'); }
  getAttraction(slug) { return this.get(`attractions/${slug}`); }

  // Tickets
  getTicketPlans() { return this.get('tickets/plans'); }
  purchaseTicket(data) { return this.post('tickets/purchase', data); }
  getMyTickets() { return this.get('tickets/my-tickets'); }
  async downloadTicket(ticketId) {
    const response = await fetch(`${this.baseUrl}/tickets/download/${ticketId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('hp_token')}`
      }
    });
    if (!response.ok) {
      const json = await response.json();
      throw new Error(json.error || 'Download failed');
    }
    return response.blob();
  }
  getCardBalance(ean13) { return this.get(`tickets/balance/${ean13}`); }

  // Payment
  initPayment(data) { return this.post('payment/init', data); }
  handlePaymentCallback(queryString) { return this.get(`payment/callback${queryString}`); }
  checkPaymentStatus(orderNumber) { return this.get(`payment/status/${orderNumber}`); }

  // Events & News
  getEvents() { return this.get('events'); }
  getUpcomingEvents() { return this.get('events/upcoming'); }
  getEvent(slug) { return this.get(`events/${slug}`); }
  getNews(page = 1) { return this.get(`news?page=${page}`); }
  getNewsArticle(slug) { return this.get(`news/${slug}`); }

  // Gallery
  getGallery(album) { return this.get(`gallery${album ? `?album=${album}` : ''}`); }

  // Contact
  submitContact(data) { return this.post('contact', data); }
  subscribe(email) { return this.post('newsletter/subscribe', { email }); }

  // Settings & Reviews
  getSettings() { return this.get('settings'); }
  getReviews() { return this.get('reviews'); }
  getParkRules() { return this.get('park-rules'); }
}

export default new ApiService();
